"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pie2D = void 0;
const react_1 = __importStar(require("react"));
const victory_1 = require("victory");
const ChartStyles_1 = require("../helpers/ChartStyles");
const StandardChart_1 = __importDefault(require("../helpers/StandardChart"));
function Pie2D(props) {
    const { hideTotal = false, fontSize, data, width = 150, height = 150 } = props;
    let calcFontSize = Math.max(Math.min(fontSize ? fontSize : Math.ceil(height / 14), 20), 12);
    return (0, react_1.useMemo)(() => {
        const total = data === null || data === void 0 ? void 0 : data.reduce((p, c) => p + c.y, 0);
        const innerRadius = Math.min(width, height) / 4;
        return (react_1.default.createElement(StandardChart_1.default, Object.assign({}, props, { svgComponents: !hideTotal && (react_1.default.createElement("text", { x: width / 2, y: height / 2 + 5, textAnchor: "middle", style: Object.assign(Object.assign({}, ChartStyles_1.ChartStyles.h1), { fontSize: calcFontSize }) }, total)) }),
            react_1.default.createElement(victory_1.VictoryPie, { width: width, data: data.map(d => (Object.assign(Object.assign({}, d), { label: d.label.split(' ').join('\n') }))), labelComponent: react_1.default.createElement(victory_1.VictoryTooltip, { renderInPortal: false, flyoutStyle: {
                        fill: ({ index }) => { var _a; return ((_a = data === null || data === void 0 ? void 0 : data[index]) === null || _a === void 0 ? void 0 : _a.color2) || 'black'; },
                        stroke: 'white',
                        strokeWidth: 4,
                    }, style: { fontSize: calcFontSize, fill: 'white' }, cornerRadius: innerRadius, flyoutWidth: innerRadius * 2, flyoutHeight: innerRadius * 2, center: { x: width / 2, y: height / 2 }, dy: 10, pointerLength: 0 }), height: height, standalone: false, animate: ChartStyles_1.ChartStyles.anim, innerRadius: innerRadius, padAngle: 1, style: { data: ChartStyles_1.ChartStyles.data } })));
    }, [data, width, height, props, hideTotal, calcFontSize]);
}
exports.Pie2D = Pie2D;
exports.default = Pie2D;
